class Termin {
    constructor() {
        this.terminSetting = {
            wid: null,
            dz: null
        };
        this.hoursElement = $("#hours");
        this.animateDuration = 600;
        this.eventLinkButton = $("#event-link-button");
        this.lang = 'pl';
    }

    translate(textSymbol) {
        const that = this;
        let messages = {
            brak_terminow: {
                pl: "Brak dostępnych terminów godzinowych rozpoczynających się w wybranym dniu. Proszę wybrać inną datę",
                en: "There are no available events starting on the selected date, please choose another date",
                de: "Für das ausgewählte Datum sind keine stündlichen Termine verfügbar. Bitte wählen Sie ein anderes Datum."
            },
            brak_limitow: {
                pl: 'brak limitów',
                en: 'no limits',
                de: 'keine  limit',
            },
            dostepne: {
                pl: 'Dostępne bilety',
                en: 'Available tickets',
                de: 'Verfügbare Tickets',
            }

        };

        if (
            messages[textSymbol] &&
            messages[textSymbol][that.lang]
        ) {
            return messages[textSymbol][that.lang];
        } else {
            return textSymbol;
        }
    }

    checkIfDateSelected() {
        const that = this;
        this.terminSetting.dz = that.getUrlParameter("dz");
        this.terminSetting.wid = that.getUrlParameter("wid");
        that.setCurrentLang();
        that.pobierzTerminyDlaDnia();
    }

    setCurrentLang() {
        const that = this;
        let lang = $('.language-selector .current-lang').data('lang');
        if ($.inArray(lang, ['pl', 'en', 'de']) !== -1) {
            that.lang = lang;
        }
    }

    handleButtons() {
        const that = this;

        $(this.hoursElement).on("click", ".js-hours-event", function (event) {
            //$('.js-hours-event').click(function(event) {
            event.preventDefault();
            that.checkHourOfEvent($(this));
        });

        $(".js-calendar-selector-arrow-disabled").click(function (e) {
            e.preventDefault();
        });

        $(".calendar__month-day-selector").on("click", function (e) {
            e.preventDefault();

            if ($(this).hasClass("calendar__month-day-selector_disabled")) {
                return;
            }

            $(".calendar__month-day-selector").removeClass(
                "calendar__month-day-selector_selected"
            );
            $(this).addClass("calendar__month-day-selector_selected");

            that.terminSetting.dz = $(this).data("day");
            //that.terminSetting.idw = $(this).data('wid');

            that.pobierzTerminyDlaDnia();
            that.hideEventButtonLink();
        });

        $(function () {
            $("[data-toggle=\"tooltip\"]").tooltip();
        });
    }

    pobierzTerminyDlaDnia() {
        const that = this;


        if (this.terminSetting.dz) {
            $("#loading").addClass("loading_active");
            $.ajax({
                url: "/rezerwacja/termin.html",
                method: "get",
                data: {
                    terminy_json: true,
                    dz: this.terminSetting.dz,
                    wid: this.terminSetting.wid
                },
                success: function (result) {
                    $("#loading").removeClass("loading_active");
                    if (result && result.status === "complete") {
                        $("#hours, .hours__alert").addClass("d-none");

                        if (result.data && result.data.length === 0) {
                            $("#hours")
                                .removeClass("d-none")
                                .addClass("hours_alert")
                                .find(".hours__alert")
                                .removeClass("d-none")
                                .find(".hours__alert-text")
                                .text(
                                    that.translate('brak_terminow')
                                );
                            $("#hours-items").html('');
                        } else {

                            that.wypiszTerminy(result);
                        }
                    } else {
                        $(".modal-dialog")
                            .dialog({
                                title: "Błąd",
                                buttons: [
                                    {
                                        text: "Zamknij",
                                        click: function () {
                                            $(this).dialog("close");
                                        }
                                    }
                                ]
                            })
                            .html(
                                result.message ||
                                "Wystąpił błąd podczas pobierania listy terminów"
                            );
                    }
                },
                error: function (xhr, status, error) {
                    $(".modal-dialog")
                        .dialog({
                            title: "Błąd",
                            buttons: [
                                {
                                    text: "Zamknij",
                                    click: function () {
                                        $(this).dialog("close");
                                    }
                                }
                            ]
                        })
                        .html("Wystąpił błąd podczas pobierania listy terminów");
                    console.error(status);
                    console.error(error);
                }
            });
        }
    }

    wypiszTerminy(result) {
        //console.log(result);
        const that = this;
        let wid = this.terminSetting.wid;
        let terminyhHtml = "";
        if (
            result.data.length === 1 &&
            result.data[0].pokazTylkoDate === true
            //result.data[0].czyCalodniowe === true
        ) {
            //let terminBox = $($('.js-hours-event')[0]);
            //let url = $(terminBox).attr('href');
            //if(url) {
            window.location.href = '/rezerwacja/miejsca.html?id=' + result.data[0].id + '&identyfikator=' + result.data[0].identyfikator + "&wid=" + wid;
            //}
        } else {
            $("#hours").removeClass("d-none");
            $.each(result.data, function (index, row) {
                let ifEventDiasabled =
                    parseInt(row.wolne, 10) === 0 ? " hours__event_disabled" : "";

                terminyhHtml += "<li class=\"hours__item\">";
                terminyhHtml +=
                    "<a class=\"hours__event js-hours-event" +
                    ifEventDiasabled +
                    "\" href=\"/rezerwacja/miejsca.html?id=" +
                    row.id +
                    "&identyfikator=" +
                    row.identyfikator +
                    "&wid=" +
                    wid +
                    "\">" +
                    "<span class=\"hours__event-time\">" +
                    (row.pokazGodzineRozpoczeciaOrazZakoncenia === true ? row.godzina + '&dash;' + row.godzina_koniec : row.godzina) +
                    "</span><span class=\"hours__event-free-seat\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"" + that.translate('dostepne') + "\" style=\"" + (row.brakLimitow === true ? 'visibility: hidden' : '') + "\">" +
                    (row.brakLimitow === true ? that.translate('brak_limitow') : row.wolne) +
                    "</span></a>";
                terminyhHtml += "</li>";
            });

            $("#hours-items").html(terminyhHtml);
        }


    }

    getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split("&"),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split("=");

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    }

    ajaxRequestsComplete() {
        const that = this;

        $(document).ajaxComplete(function (event) {
            const className = "calendar__month-day-selector calendar__month-day-selector_selected";
            let targetClassName = event.currentTarget.activeElement.className;

            if (className === targetClassName) {
                that.scrollToAvailableHours();
            }
        });
    }

    scrollToAvailableHours() {
        const that = this;

        $("html, body").animate(
            {
                scrollTop: that.hoursElement.offset().top - 32
            },
            that.animateDuration,
            function () {
                $(this).clearQueue();
            }
        );
    }

    checkHourOfEvent(clickedHour) {
        let clickedHourLink = clickedHour.attr("href");

        clickedHour
            .closest("#hours-items")
            .find(".hours__event-time")
            .removeClass("hours__event-time_active");
        clickedHour.find(".hours__event-time").addClass("hours__event-time_active");

        this.setEventButtonLink(clickedHourLink);
    }

    setEventButtonLink(link) {
        this.showEventButtonLink();
        this.eventLinkButton.removeClass("d-none").attr("href", link);
    }

    showEventButtonLink() {
        this.eventLinkButton.removeClass("d-none");
    }

    hideEventButtonLink() {
        this.eventLinkButton.addClass("d-none");
    }

    init() {
        this.handleButtons();
        this.checkIfDateSelected();
        this.ajaxRequestsComplete();
    }
}

export default Termin;
